export default __webpack_public_path__ + "static/media/bernygroup3.5e938afb.jpg";